import pjson from '../../../package.json';

export const VERSION = pjson.version;
